import Vue from 'vue';
import {Component} from "vue-property-decorator";
import {Country} from "@/types/CheckoutFormData";
import {CheckoutStore} from "@/store";

let getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()!.split(';').shift();
};

@Component({
    name: "Mixin"
})
export class Mixin extends Vue {
    store!: CheckoutStore;
    T(key: string, variables : {[key: string]: string} = {}) {
        let translation = $translation[key] || key;
        for(let variable in variables) {
            if(variables.hasOwnProperty(variable)) {
                translation = translation.replace(new RegExp('{\\$' + variable + '}', 'g'), variables[variable]);
            }
        }
        translation = translation.replaceAll('&nbsp;', '\xa0');

        if (lang === 'ch' && translation.indexOf('<a href') > -1) {
            return translation.replaceAll('/de/', '/ch/');
        }

        return translation;
    }

    isTablet() {
        let wasTouchedBefore = getCookie("touched") !== undefined;
        return wasTouchedBefore || window.innerWidth <= 1024;
    }

    printDate(date: Date): string {
        return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
    }

    getDeviceType() {
        if (this.isTablet()) {
            // device has touchscreen
            if (window.innerWidth > window.innerHeight) {
                // landscape
                return window.innerWidth >= 960 ? 'tablet' : 'smartphone';
            }
            // portrait
            return window.innerWidth >= 768 ? 'tablet' : 'smartphone';
        }
        // no touchscreen
        return 'desktop';
    }

    get assemblyTextKey() {
        switch (
            this.store!.serverData.hasDifferentBillingAddress
                ? this.store!.serverData.deliveryAddress.country
                : this.store!.serverData.billingAddress.country
            ) {
            case 1: // germany -> fixit find better way
                return 'ch2-3-assembly-text-de';
            default:
                return 'ch2-3-assembly-text-others';
        }
    }

    // Handles special characters in base64
    decodeBase64(base64: string): string {
        const text = atob(base64);
        const length = text.length;
        const bytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
            bytes[i] = text.charCodeAt(i);
        }
        const decoder = new TextDecoder();
        return decoder.decode(bytes);
    }
}
